export default __webpack_public_path__ + "static/media/long_thumb.d47c4435.jpg";